/** Каждый # в format — один слот под цифру. */
export const countFormatSlots = (format: string, patternChar = '#'): number => {
  return format.split('').filter((char) => char === patternChar).length;
};
